__turbopack_context__.v({
  "embeddedVideo": "VideoBlock-module__Nrj0VG__embeddedVideo",
  "videoBlock": "VideoBlock-module__Nrj0VG__videoBlock",
});
